<div mat-dialog-title class="cust-modal-title">
  <h2 class="m-0">{{ parentData.title }}</h2>
  <button mat-icon-button mat-dialog-close>
    <mat-icon>close</mat-icon>
  </button>
</div>
<mat-dialog-content *ngIf="!isLocationVisible">
  <div>
    <mat-form-field appearance="outline" style="width: 100%">
      <mat-label>Name</mat-label>
      <input [(ngModel)]="newbookingData.customerName" matInput (keyup)="searchCustomerName($event)" [matAutocomplete]="auto">
      <button
    mat-button
    *ngIf="loaderForAutocomplete"
    matSuffix
    aria-label="Clear"
  >
  <mat-progress-spinner
  diameter="20"
  mode="indeterminate"
  color="accent"
  strokeWidth="3"
  style="width: 20px; height: 20px;"
> </mat-progress-spinner>
  </button>
      <mat-autocomplete #auto="matAutocomplete">
        <mat-option
          *ngFor="let item of autocompleteItems"
          (click)="selectSearchResult(item)"
        >
          {{ item.name | titlecase }} ({{item.country_code}} {{item.phone}})
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
  </div>
  <div class="row g-2 justify-content-between phone-field">
    <mat-form-field appearance="outline" class="country-code col-3">
      <mat-label>Country Code</mat-label>
      <mat-select
      [(ngModel)]="selectedCountryCode"
      required
      (selectionChange)="onCountrySelected($event)">
      <mat-select-trigger>
        {{ selectedCountryCode.flag }} {{ selectedCountryCode.name }}
            {{ "(" + selectedCountryCode.dial_code + ")" }}
      </mat-select-trigger>
      
      <mat-option>
        <ngx-mat-select-search
          noEntriesFoundLabel="no results found"
          name="countrysearch"
          placeholderLabel="Enter country name"
          [formControl]="searchString"
          (keyup)="onKey()"
        ></ngx-mat-select-search>
      </mat-option>
      <mat-option *ngFor="let country of countryList" [value]="country">
        {{ country.flag }} {{ country.name }}
        {{ "(" + country.dial_code + ")" }}
      </mat-option>
    </mat-select>
    </mat-form-field>
    <mat-form-field class="mobile_form col-9" appearance="outline">
      <mat-label>Phone</mat-label>
      <input
        [(ngModel)]="newbookingData.customerPh"
        matInput
        type="tel"
        smNumericOnly
        minLength="3"
        maxlength="17"/>
      <mat-hint
        style="color: red; font-size: 13px"
        align="end"
        *ngIf="
          newbookingData.customerPh &&
          newbookingData.customerPh != '' &&
          newbookingData.customerPh.length < 3
        "
        >Enter a valid phone number.</mat-hint
      >
    </mat-form-field>
  </div>

  <h3 class="servicet_heading">Date and time</h3>
  <div class="chip_cont" style="border-bottom: 1px solid lightgray;margin-top: 15px; margin-bottom: 24px; padding-bottom: 10px;">
    <mat-chip-listbox aria-label="Fish selection" class="mb-1">
      <mat-chip style="margin-right: 8px;"
        [ngClass]="{ selectedPurple: selectedBookingType == 1 }"
        (click)="changeChip(1)"
        >Today
      </mat-chip>
    </mat-chip-listbox>

    <mat-chip-listbox aria-label="Fish selection" class="mb-1" style="margin-right: 10px;">
      <mat-chip style="margin-right: 8px;"
        [ngClass]="{ selectedPurple: selectedBookingType == 4 }"
        (click)="changeChip(4)"
        >Tomorrow
      </mat-chip>
    </mat-chip-listbox>
    <mat-chip-listbox aria-label="Fish selection" class="mb-1">
      <mat-chip style="margin-right: 8px;"
        [ngClass]="{ selectedPurple: selectedBookingType == 5 }"
        (click)="onSelectDate()"
        >{{ selectedDate && selectedBookingType == 5 ? (selectedDate | date : "longDate") : "Select Date" }}
      </mat-chip>
    </mat-chip-listbox>
    <mat-chip-listbox aria-label="Fish selection" class="mb-1">
      <mat-chip
        
        [ngClass]="{ selectedPurple:  startTime && endTime }"
        (click)="onSelectSlot()"
        >{{ (startTime && endTime) ? tConv24(startTime) + ' - ' + tConv24(endTime) : 'Select Slot' }}
      </mat-chip>
    </mat-chip-listbox>
  </div>
  
  <!-- SERVICES -->
  <h3 class="servicet_heading" style="margin-bottom: 0px;" *ngIf="isEntityIndividual == '0'"> {{ parentData.data.serviceType == "1" ? "Shop services" : (parentData.data.serviceType == '0' ? 'Home services' : "Virtual services")  }}</h3>
  <h3 class="servicet_heading" style="margin-bottom: 0px;" *ngIf="isEntityIndividual == '1'"> {{ parentData.data.serviceType == "1" ? "In-premise services" : (parentData.data.serviceType == '0' ? 'Home services' : "Virtual services")  }}</h3>
  <div class="chip_cont" style="padding: 20px 0px; margin-bottom: 20px;">
    <mat-chip-listbox class="example-chip" *ngIf="serviceList.length > 0">
      <div *ngFor="let item of serviceList">
        <mat-chip *ngIf="item.toShow"  (click)="selectServices(item)">{{ item.serviceName }}</mat-chip>
      </div>
    </mat-chip-listbox>
    <p *ngIf="serviceList.length == 0" style="color: #888888;">No service added</p>
  </div>

<!-- PRODUCTS -->

<h3 class="servicet_heading" style="margin-bottom: 0px;" *ngIf="productsList.length > 0"> Sellable products </h3>

<div class="chip_cont" style="padding: 20px 0px; margin-bottom: 20px;" *ngIf="productsList.length > 0">
  <mat-chip-listbox class="example-chip" *ngIf="productsList.length > 0">
    <div *ngFor="let item of productsList">
      <mat-chip
        *ngIf="item.toShow"
        
        (click)="selectProducts(item)"
        >{{ item.product_name }}
      </mat-chip>
    </div>
  </mat-chip-listbox>
  <p *ngIf="productsList.length == 0" style="color: #888888;">No products added</p>
</div>

<!-- SELECTED JOBS -->
  <h3 style="color: #222; font-weight: bold;" *ngIf="selectedJobs.length > 0">Job selected</h3>
  <div class="" *ngIf="selectedJobs.length > 0">
   
    <div class="open_segnj" *ngFor="let item of selectedJobs; let i = index;">
      <div
        style="
          width: fit-content;
          background: #ffc107;
          padding: 8px 20px;
          border-radius: 34px;
          margin-bottom: 20px;">
        <p style="margin: 0px; font-weight: 500; font-size: 16px">
          {{ item.serviceName }}
        </p>
      </div>
      <div class="inc_dec_cont">
        <div class="cont_span">
        <span style="margin-left: 10px;border: 1px solid #a2a2a2;padding: 10px;border-radius: 10px;">
          <button
          (click)="decreaseServiceCount(item,i)"
          style="background: none;
          border: 1px solid #a2a2a2;
          border-radius: 25px;
          width: 25px;
          height: 25px;">
          <mat-icon class="material-icons-outlined" style="    font-size: 16px;
          position: relative;
          top: 2px;
          left: -3px;
          color: #666666;
          height: auto;
          width: auto;">remove</mat-icon>
          </button>
          <span style="margin: 0 15px;"> {{item.selectedCount}} </span>
          <button 
          (click)="increaseServiceCount(item,i)"
          style="background: none;
          border: 1px solid #a2a2a2;
          border-radius: 25px;
          width: 25px;
          height: 25px;">
          <mat-icon style="    font-size: 16px;
          position: relative;
          top: 2px;
          left: -3px;
          color: #666666;
          height: auto;
          width: auto;" class="material-icons-outlined">add</mat-icon>
          </button>
        </span>
      </div>
      <div class="profi_section_remove">
        <span
        (click)="removeSelectedJobs(item)"
        style="text-decoration: underline;
        margin-left: 20px;
        display: inline-block;
        cursor: pointer;">
          Remove
        </span>
      </div>
      </div>
    </div>
  </div>


  <!-- SELECTED PRODUCTS -->
  <h3 style="color: #222;font-weight: bold;" *ngIf="selectedProducts.length > 0">Products selected</h3>
  <div style="margin-bottom: 20px;" class="" *ngIf="selectedProducts.length > 0" >
    <div class="open_segnj" *ngFor="let item of selectedProducts; let i = index;">
      <div
        style="
          display: inline-block;
          width: fit-content;
          background: #ffc107;
          padding: 8px 20px;
          border-radius: 34px;  margin-bottom: 20px;">
        <p style="margin: 0px; font-weight: 500; font-size: 16px">
          {{ item.product_name }}
        </p>
      </div>
      <div class="inc_dec_cont">
      <div class="cont_span">
        <span style="margin-left: 10px;border: 1px solid #a2a2a2; padding: 10px; border-radius: 10px;">
          <button
          (click)="decreaseProductCount(item,i)"
          style="background: none;
          border: 1px solid #a2a2a2;
          border-radius: 25px;
          width: 25px;
          height: 25px;">
          <mat-icon class="material-icons-outlined" style="    font-size: 16px;
          position: relative;
          top: 2px;
          left: -3px;
          color: #666666;
          height: auto;
          width: auto;">remove</mat-icon>
          </button>
          <span style="    margin: 0 15px;"> {{item.selectedCount}} </span>
          <button 
          (click)="increaseProductCount(item,i)"
          style="background: none;
          border: 1px solid #a2a2a2;
          border-radius: 25px;
          width: 25px;
          height: 25px;">
          <mat-icon style="    font-size: 16px;
          position: relative;
          top: 2px;
          left: -3px;
          color: #666666;
          height: auto;
          width: auto;" class="material-icons-outlined">add</mat-icon>
          </button>
        </span>
      
      </div>
      <div class="profi_section_remove">
        <span (click)="removeSelectedProducts(item)"
        style="text-decoration: underline;
        margin-left: 20px;
        display: inline-block;
        cursor: pointer;">
          Remove
        </span>
        </div>
      </div>
    </div>
  </div>



   <!-- create invice new design added -->
   <div class="other_itemi_secty">
    <div class="oth_headingrt">
      <h3>Other items</h3>  
    </div>
    <form [formGroup]="form">
      <div formArrayName="items">
        <div *ngFor="let item of items.controls; let i = index" [formGroupName]="i" class="repect_under">
          <div class="ad">
            <div class="asa">
              <div class="item_name_tht">
                <mat-form-field appearance="outline" class="full-width">
                  <mat-label>Item name</mat-label>
                  <input matInput formControlName="name" [matAutocomplete]="auto" type="text" placeholder="Enter item name">
                  <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayItemName">
                    <mat-option *ngFor="let option of filteredOptions[i] | async" [value]="option">
                      {{ option.item_name }}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
              </div>
            </div>
            <div class="ddf">
              <mat-form-field appearance="outline" >
                <mat-select class="w-100" formControlName="tax_slab">
                            <mat-option value="default" >
                              Select a tax
                            </mat-option>
                            <mat-option [value]="item.hash_id" *ngFor="let item of taxSlabData">
                              {{isEntityForeign == '0' ? item.tax_name : item.slab_name}}
                            </mat-option>
                           
                          </mat-select>
             </mat-form-field>
            </div>
            <div class="adad">
              <div class="plus_tht newclassw" style="padding-top: 0px;">
               <div class="flexsc">
                <div class="inc_dec_cont newinc">
                  <span class="cont_span" style="top: 0px;border: 1px solid #a2a2a2;padding: 13px !important;border-radius: 10px; position: relative; bottom: 0px;  width: 125px; display: block;  margin-right: 10px;">
                    <button type="button" class="inc_dec_btn"  (click)="decreaseCount(i)">
                      <mat-icon>remove</mat-icon>
                    </button>
                    <span style="margin: 0 15px;">{{ item.get('count')!.value }}</span>
                    <button type="button" class="inc_dec_btn"  (click)="increaseCount(i)">
                      <mat-icon>add</mat-icon>
                    </button>
                  </span>
                </div>
              </div>
                <div class="item_name_tht itempricex">
                  <mat-form-field appearance="outline">
                    <mat-label>Item price</mat-label>
                    <input matInput formControlName="price" placeholder="Enter item price" smDecimalOnly  type="number" >
                  </mat-form-field>
                </div>
              
              </div>


            </div>
          
            <span class="remove_btn" (click)="removeFormField(i)">Remove</span>
          </div>
        </div>
      </div>
    
      <div class="add_item_btbh">
        <button type="button" mat-flat-button color="accent" (click)="addFormField()">
          <mat-icon>add</mat-icon>
          Add item
        </button>
      </div>
    </form>
    

  </div>


  <!-- create invice new design end -->









  <div>
    <mat-form-field appearance="outline" style="width: 100%">
      <mat-label>Cost</mat-label>
      <input
        [(ngModel)]="formattedPrice"
        matInput
        
        [disabled]="true"
      />
      
    </mat-form-field>
  </div>
  <div>
    <mat-form-field appearance="outline" style="width: 100%">
      <mat-label>Notes</mat-label>
      <textarea [(ngModel)]="newbookingData.note" matInput></textarea>
      <!-- <mat-icon matSuffix class="material-icons-outlined">message</mat-icon> -->
    </mat-form-field>
  </div>
</mat-dialog-content>


<mat-dialog-content *ngIf="isLocationVisible">
<div class="col-sm-12" style="padding: 0;">
    <div
      class="content"
      style=""
    >
      <!-- <h1>New business creation (step 4 of 4)</h1> -->
      <div class="sub_headingt">
        <!-- <h3></h3> -->
      </div>
      <div class="map-holder">
        <div
          #mapContainer
          id="map-container"
          style="height: 300px; width: 100%"
        ></div>
      </div>
      <div>
        <p style="color: #888; margin-bottom: 30px;">
          Add address where you would like to be served. You can drag the map
          pointer for a precise location. A well defined address will help the
          service provider to locate the address correctly.
        </p>
      </div>
      <div class="map-form-holder">
        <!-- <h4>Address</h4> -->
       <mat-form-field appearance="outline">
          <mat-label>Enter location</mat-label>
          <input
          (input)="onInputChange()"
          placeholder="Select a location"
            [matAutocomplete]="auto"
            [(ngModel)]="this.formattedAddress"
            matInput
            #input
          />
              <mat-autocomplete #auto="matAutocomplete" >
                          <mat-option
                            *ngFor="let item of googleAutoCompleteItems"
                            (click)="selectItem(item)"
                          >
                            {{ item.description }}
                          </mat-option>
                        </mat-autocomplete>
        </mat-form-field>
      </div>
                  <div class="">
                    <!-- <h4>Address</h4> -->
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Zipcode</mat-label>
                      <input
                      [(ngModel)]="this.selectedLocation.zip"
                        type="text"
                        matInput
                        #input
                      />
                    </mat-form-field>
                  </div>
                  <div class="">
                    <!-- <h4>Address</h4> -->
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>House number</mat-label>
                      <input
                      [(ngModel)]="houseNumber"
                        type="text"
                        matInput
                        #input
                      />
                    </mat-form-field>
                  </div>
      <div class="">
        <!-- <h4>Address</h4> -->
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Street name</mat-label>
          <input
            [(ngModel)]="streetName"
            type="text"
            matInput
            #input
          />
        </mat-form-field>
      </div>
      <div class="">
        <!-- <h4>Address</h4> -->
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Landmark</mat-label>
          <input
[(ngModel)]="landmark"
           
            type="text"
            matInput
            #input
          />
        </mat-form-field>
      </div>
      <div class="">
         <div class="row g-2 justify-content-between phone-field">
    <mat-form-field appearance="outline" class="country-code col-3">
      <mat-label>Country Code</mat-label>
      <mat-select
      [(ngModel)]="contactselectedCountryCode"
      required
      (selectionChange)="onCountrySelected($event)">
      <mat-select-trigger>
            {{ "(" + contactselectedCountryCode.dial_code + ")" }}
      </mat-select-trigger>
      
      <mat-option>
        <ngx-mat-select-search
          noEntriesFoundLabel="no results found"
          name="countrysearch"
          placeholderLabel="Enter country name"
          [formControl]="searchString"
          (keyup)="onKey()"
        ></ngx-mat-select-search>
      </mat-option>
      <mat-option *ngFor="let country of countryList" [value]="country">
        {{ "(" + country.dial_code + ")" }}
      </mat-option>
    </mat-select>
    </mat-form-field>
    <mat-form-field class="mobile_form col-9" appearance="outline">
      <mat-label>Contact phone</mat-label>
      <input
        matInput
        type="tel"
        [(ngModel)]="phone"
        minLength="3"
        maxlength="17"/>
      <!-- <mat-hint
        style="color: red; font-size: 13px"
        align="end"
        *ngIf="
          newbookingData.customerPh &&
          newbookingData.customerPh != '' &&
          newbookingData.customerPh.length < 3
        "
        >Enter a valid phone number.</mat-hint 
      >-->
    </mat-form-field>
  </div>
      </div>
    </div>
    <!-- <div class="footer">
      <button mat-button style="font-size: 16px" (click)="onClickBack(4)">
        <mat-icon>arrow_back</mat-icon>
        Back
      </button>
      <button
        (click)="onSubmit()"
        [disabled]="!formattedAddress"
        mat-flat-button
        color="accent"
        class="next"
      >
        Save
      </button>
    </div> -->
  </div>

</mat-dialog-content>


<mat-dialog-actions align="end" style="padding-top: 0px;">
  <div class="create_newrt">
  <button
    mat-button
    mat-dialog-close
    *ngIf="!isLocationVisible"
  >
    Cancel
  </button>
  <button
    *ngIf="parentData.data.serviceType == 1"    
    mat-flat-button
    color="accent"
    (click)="onPost()"
    [disabled]="selectedJobs.length == 0 || formChecker() || !endTime || !startTime || form.invalid"
  >
    Create new booking
  </button>
  <!-- FOR HOME -->
  <!-- STEP 1 FOR HOME -->
  <button
  *ngIf="parentData.data.serviceType == 0 && !isLocationVisible"    
  mat-flat-button
  color="accent"
  [disabled]="selectedJobs.length == 0 || formChecker() || !endTime || !startTime || form.invalid"
   (click)="gotoaddressorToggle()"
  >
  Next
</button>
<!-- STEP 2 FOR HOME (LOCATION) -->
 <button
    mat-button
  *ngIf="parentData.data.serviceType == 0 && isLocationVisible"
  (click)="gotoaddressorToggle()"
  >
    Back
  </button>
  <button
  *ngIf="parentData.data.serviceType == 0 && isLocationVisible"    
  mat-flat-button
  color="accent"
  (click)="onPost()"
  [disabled]="!formattedAddress || !phone || phone.length < 3 || !selectedLocation.zip"
  >
  Create new booking
</button>
<!-- FOR HOME -->
  <button
    *ngIf="parentData.data.serviceType == 2"
    mat-flat-button
    color="accent"
    (click)="onPost()"
    [disabled]="selectedJobs.length == 0 || formChecker() || form.invalid"
  >
    Create new booking
  </button>

  <!-- <button
    mat-button
    *ngIf="selectedBookingType == 4"
    style="border: 1px solid #b48700"
    [disabled]="selectedJobs.length == 0 || formChecker()"
    (click)="allDoneAndRelease()"
  >
    All done and release
  </button>
  <button
    mat-button
    *ngIf="selectedBookingType == 4"
    style="border: 1px solid #b48700"
    [disabled]="selectedJobs.length == 0 || formChecker()"
    (click)="partiallyDone()"
  >
    Partially done and release
  </button>
  <button
    *ngIf="selectedBookingType == 4"
    mat-flat-button
    color="accent"
    (click)="allDone()"
    [disabled]="selectedJobs.length == 0 || formChecker()"
  >
    All done and produce bill
  </button> -->
</div>
</mat-dialog-actions>
